/* Dansk katalog for locale-investment-quick-purchase.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'investments.quickPurchaseTitle': 'Kontrollér og godkend købet',
  'investments.quickPurchaseIntro': 'Plumme har læst dokumentet og klargjort købet. Kontrollér beløbene, og godkend.',
  'investments.quickExistingInstrument': 'Købet registreres på eksisterende investering: {name}.',
  'investments.quickClassification': 'Regnskabskonto',
  'investments.quickCurrentAsset': '1810 · Markedsbaseret omsætningsaktiv',
  'investments.quickCurrentAssetName': 'Markedsbaserede aktier og investeringsforeningsandele',
  'investments.quickLongTerm': '1350 · Langsigtet investering',
  'investments.quickBankRequired': 'Virksomheden skal have en aktiv NOK-bankkonto, før købet kan bogføres.',
  'investments.quickTaxLater': 'Afklares automatisk ud fra års- og skattedokumentationen',
  'investments.editCurrency': 'Skift valuta',
  'investments.editFact': 'Rediger {field}',
  'investments.quickActualNokAmount': 'Faktisk debiteret i NOK',
  'investments.quickActualNokHelp': 'Indtast NOK-beløbet, der faktisk blev debiteret for købet i {currency}.',
  'investments.quickResult': 'Når du godkender, opretter Plumme investeringen, bogfører købet og opdaterer beholdningen. En entydig banktransaktion kobles automatisk nu eller næste gang, Investeringer åbnes.',
  'investments.quickApprove': 'Godkend, bogfør og opdater beholdning',
  'investments.quickApproving': 'Bogfører købet …',
  'investments.quickSaleTitle': 'Kontrollér og godkend salget',
  'investments.quickSaleIntro': 'Plumme har læst salgsbilaget og beregnet regnskabs- og skatteeffekten ud fra registreret historik.',
  'investments.saleCalculating': 'Beregner FIFO og anskaffelsesgrundlag …',
  'investments.saleCannotQuickApprove': 'Dette mangler, før salget kan hurtiggodkendes',
  'investments.saleInstrumentMissing': 'Investeringen findes ikke i registret. Registrér primobeholdning eller tidligere køb først.',
  'investments.saleInstrumentAmbiguous': 'Flere investeringer matcher dokumentet. Vælg den rigtige investering manuelt.',
  'investments.saleTaxTreatmentMissing': 'Skattebehandlingen er ikke afklaret for investeringen.',
  'investments.instrumentTypeUnsupported': 'Instrumenttypen er genkendt, men bogføring for denne type understøttes endnu ikke.',
  'investments.netSettlement': 'Nettoafregning',
  'investments.releasedBookCost': 'Frigivet regnskabsmæssig anskaffelsessum',
  'investments.releasedBookValue': 'Frigivet bogført værdi',
  'investments.releasedTaxCost': 'Frigivet skattemæssig anskaffelsessum',
  'investments.bookProfitLoss': 'Regnskabsmæssig gevinst/tab',
  'investments.taxProfitLoss': 'Skattemæssig gevinst/tab',
  'investments.fifoCalculation': 'Beregnet FIFO',
  'investments.quickSaleResult': 'Godkendelse bogfører salget, opdaterer beholdningen og kobler en entydig bankafregning automatisk.',
  'investments.quickApproveSale': 'Godkend, bogfør og opdater beholdning',
  'investments.completeSale': 'Udfyld salget',
});
